var map = {
	"./ion-action-sheet.entry.js": [
		"754b",
		"chunk-cc885ef2"
	],
	"./ion-alert.entry.js": [
		"43c0",
		"chunk-6e1ebba7"
	],
	"./ion-app_8.entry.js": [
		"8602",
		"chunk-343d842a"
	],
	"./ion-avatar_3.entry.js": [
		"09fa",
		"chunk-4abc2f07"
	],
	"./ion-back-button.entry.js": [
		"36dd",
		"chunk-6b3808c8"
	],
	"./ion-backdrop.entry.js": [
		"4360",
		"chunk-2d0c0a6f"
	],
	"./ion-button_2.entry.js": [
		"d0f6",
		"chunk-7857c4af"
	],
	"./ion-card_5.entry.js": [
		"c9d4",
		"chunk-1dc7c1c5"
	],
	"./ion-checkbox.entry.js": [
		"e1f3",
		"chunk-6f5ed6b2"
	],
	"./ion-chip.entry.js": [
		"7332",
		"chunk-0f4297b0"
	],
	"./ion-col_3.entry.js": [
		"fc20",
		"chunk-2d2378b1"
	],
	"./ion-datetime_3.entry.js": [
		"5a01",
		"chunk-2b966f81"
	],
	"./ion-fab_3.entry.js": [
		"b907",
		"chunk-60445926"
	],
	"./ion-img.entry.js": [
		"c070",
		"chunk-2d215cbc"
	],
	"./ion-infinite-scroll_2.entry.js": [
		"da5c",
		"chunk-2d228901"
	],
	"./ion-input.entry.js": [
		"7ab7",
		"chunk-7885c3cc"
	],
	"./ion-item-option_3.entry.js": [
		"3063",
		"chunk-26f4df71"
	],
	"./ion-item_8.entry.js": [
		"f5bb",
		"chunk-1fc2d15c"
	],
	"./ion-loading.entry.js": [
		"7000",
		"chunk-3582ae12"
	],
	"./ion-menu_3.entry.js": [
		"9321",
		"chunk-013061d2"
	],
	"./ion-modal.entry.js": [
		"4ef6",
		"chunk-52eabdec"
	],
	"./ion-nav_2.entry.js": [
		"be71",
		"chunk-5d875e1a"
	],
	"./ion-popover.entry.js": [
		"a82b",
		"chunk-304e7324"
	],
	"./ion-progress-bar.entry.js": [
		"d2d3",
		"chunk-4da1c3e4"
	],
	"./ion-radio_2.entry.js": [
		"875d",
		"chunk-022a7fbd"
	],
	"./ion-range.entry.js": [
		"5c68",
		"chunk-09e1e8fb"
	],
	"./ion-refresher_2.entry.js": [
		"9d86",
		"chunk-63f0a1ff"
	],
	"./ion-reorder_2.entry.js": [
		"b263",
		"chunk-06a7f5c0"
	],
	"./ion-ripple-effect.entry.js": [
		"4938",
		"chunk-2d0c20a0"
	],
	"./ion-route_4.entry.js": [
		"9397",
		"chunk-7db91453"
	],
	"./ion-searchbar.entry.js": [
		"391e",
		"chunk-1ab29a11"
	],
	"./ion-segment_2.entry.js": [
		"7d28",
		"chunk-7299f250"
	],
	"./ion-select_3.entry.js": [
		"95f1",
		"chunk-e0927678"
	],
	"./ion-slide_2.entry.js": [
		"e716",
		"chunk-2d225f0d"
	],
	"./ion-spinner.entry.js": [
		"9c8d",
		"chunk-5f259812"
	],
	"./ion-split-pane.entry.js": [
		"3404",
		"chunk-2d0b991b"
	],
	"./ion-tab-bar_2.entry.js": [
		"9279",
		"chunk-a115bba0"
	],
	"./ion-tab_2.entry.js": [
		"4e97",
		"chunk-5db12fb6"
	],
	"./ion-text.entry.js": [
		"2129",
		"chunk-3135c405"
	],
	"./ion-textarea.entry.js": [
		"53b2",
		"chunk-c602cac6"
	],
	"./ion-toast.entry.js": [
		"2f7b",
		"chunk-0149e7ec"
	],
	"./ion-toggle.entry.js": [
		"2143",
		"chunk-68d95220"
	],
	"./ion-virtual-scroll.entry.js": [
		"f0c6",
		"chunk-2d22bf33"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "90b7";
module.exports = webpackAsyncContext;